import Service, { service } from '@ember/service';
import type CableService from './cable.ts';

export type IndexProgress = {
  batchId: string;
  completed: number;
  failures: number;
  pending: number;
  progress: number;
  total: number;
  type: string;
  status: 'queued' | 'running' | 'finished' | 'failed';
};

export default class RebuildIndexService extends Service {
  @service declare cable: CableService;

  private channelParams: object | null = null;

  connect(apiHost: string, apiKey: string, token: string) {
    this.cable.connect(apiHost, apiKey, token);
  }

  subscribe(model: string, onUpdate: (msg: IndexProgress) => void) {
    this.channelParams = {
      channel: 'ReindexProgressChannel',
      model,
    };

    this.cable.subscribe(this.channelParams, {
      received: (msg) => {
        onUpdate(msg as IndexProgress);
      },
    });
  }

  unsubscribe() {
    if (this.channelParams) {
      this.cable.unsubscribe(this.channelParams);
      this.channelParams = null;
    }
  }
}
